import storeLogo from "../assets/storeLogo.svg";
import { Box, Typography } from "@mui/material";

export const Header = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "34px",
          lineHeight: "40px",
          fontWeight: "600",
          marginTop: "16px",
        }}
      >
        Cede Ballpit dApp
      </Typography>
      <img src={storeLogo} alt="Cede Store Logo" style={{ width: "100%", maxWidth: "150px", marginTop: "16px" }} />
    </Box>
  );
};
